import React from 'react';
import styled from 'styled-components';

import { theme, Row, Column, Text } from '@dls/web';

const PanelMinimizeText = styled(Text)`
  font-size: 8px !important;
`;

const StyledPanelMinimize = styled.div`
  background: ${theme.main.colours.tertiary.l5};
  display: inline-flex;
  justify-content: center;
  width: auto;
  height: auto;
  border-radius: 0px 0px 10px 10px;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  padding: 4px;
  z-index: 1000;
`;

const ItemGroup = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-child):after {
    content: '';
    bottom: 0;
    left: 0;
    right: 0;
    height: 25px;
    border-right: 1px solid black;
    margin: 0 8px;
    z-index: -1;
  }

  & > * {
    margin: 0 4px;

    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
`;

type Item = {
  icon: any;
  label: string;
  onClick?: () => void;
};

type PanelMinimizeProps = {
  items: Item[][];
  onClick: () => void;
};

export const PanelMinimize = ({ items, onClick }: PanelMinimizeProps) => {
  return (
    <StyledPanelMinimize onClick={onClick}>
      {items.map((group: Item[]) => {
        return (
          <ItemGroup>
            {group.map((item: Item) => {
              return (
                <Row
                  middle="xs"
                  style={{ flexDirection: 'column' }}
                  onClick={item?.onClick || null}
                >
                  <Column noGutter>{item.icon}</Column>
                  <Column noGutter>
                    <PanelMinimizeText>{item.label}</PanelMinimizeText>
                  </Column>
                </Row>
              );
            })}
          </ItemGroup>
        );
      })}
    </StyledPanelMinimize>
  );
};
